import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LayoutShell from "./layout/LayoutShell";
import ProtectedRoute from "./Routes/ProtectedRoutes";

/* Replace with your real login component */
import Login from "./Authentication/Login";

function App() {
  const isAuth = localStorage.getItem("isAuthenticated");

  return (
    <Router>
      <Routes>

        {/* Public Route */}
        <Route
          path="/login"
          element={
            isAuth ? <Navigate to="/" replace /> : <Login />
          }
        />

        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <LayoutShell />
            </ProtectedRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;